import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const FacultyAuth = () => {
  const [facultyEmail, setFacultyEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    if (!facultyEmail.trim() || !password.trim()) {
      setError("Please enter Faculty Email and Password");
      setLoading(false);
      return;
    }

    try {
      const payload = {
        facultyEmail: facultyEmail.trim(),
        facultyPassword: password,
      };

      const response = await axios.post(
        "https://admin.stipsredu.in/faculty/login",   
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response.data;

      if (response.status === 200 && data.message?.toLowerCase().includes("successful")) {
        // Store token if backend returns one
        if (data.token) {
          localStorage.setItem("facultyToken", data.token);
        }

        // Optional: store basic user info
        // if (data.user) {
        //   localStorage.setItem("facultyUser", JSON.stringify(data.user));
        // }

        navigate("/faculty-dashboard");
      } else {
        setError(data.message || "Login failed. Please try again.");
      }
    } catch (err) {
      console.error("Login error:", err);

      if (err.response) {
        // 400, 401, 404, etc.
        setError(err.response.data?.message || "Invalid email or password");
      } else if (err.request) {
        setError("Cannot connect to the server. Is the backend running?");
      } else {
        setError("An unexpected error occurred. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#112E65] to-[#1e3a8a] px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-[#112E65] mb-2">Faculty Login</h1>
          <p className="text-sm text-gray-500">
            Login credentials are provided by the Principal
          </p>
        </div>

        {/* Error display */}
        {error && (
          <div className="mb-6 p-3 bg-red-50 border-l-4 border-red-500 text-red-700 rounded">
            {error}
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Faculty Email */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Faculty Email
            </label>
            <input
              type="email"
              value={facultyEmail}
              onChange={(e) => setFacultyEmail(e.target.value)}
              placeholder="Enter your faculty email"
              disabled={loading}
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#112E65] disabled:bg-gray-100"
            />
          </div>

          {/* Password */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                disabled={loading}
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#112E65] disabled:bg-gray-100"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                disabled={loading}
                className="absolute right-3 top-3 text-sm text-[#112E65] font-medium hover:underline disabled:opacity-50"
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          {/* Submit */}
          <button
            type="submit"
            disabled={loading}
            className={`w-full py-3 bg-[#112E65] text-white rounded-lg font-semibold transition
              ${loading ? "opacity-70 cursor-not-allowed" : "hover:bg-[#0d234d]"}`}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        {/* Principal button */}
        <button
          onClick={() => navigate("/principal-login")}
          disabled={loading}
          className={`w-full mt-4 py-3 border-2 border-[#112E65] text-[#112E65] rounded-lg font-semibold transition
            ${loading ? "opacity-50 cursor-not-allowed" : "hover:bg-[#112E65] hover:text-white"}`}
        >
          Principal Login
        </button>

        <p className="text-xs text-center text-gray-400 mt-6">
          Unauthorized access is strictly prohibited
        </p>
      </div>
    </div>
  );
};

export default FacultyAuth;